import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { OPT_IN_BETA_JOINED_SCREEN_SHOWN, OPT_IN_BETA_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { apiFetchData } from 'apps/auth/helpers/api';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import usePreloadStoryImages from 'apps/auth/hooks/usePreloadStoryImages';

const BetaPromoStories = (props) => {
    const { notNowButton, optInButton } = usePageMessages();
    const slides = props.sliders?.slides;
    const duration = props.sliders?.duration * 1000;
    const imagesLoaded = usePreloadStoryImages(slides);

    const doRequest = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        amplitude.getInstance().logEvent(OPT_IN_BETA_SCREEN_SHOWN);
        props.popupFullwidthRef.current?.close();
        apiFetchData('/auth/profile/opt-in/confirm.action')
            .then((json) => {
                if (json?.extra) {
                    props.addExtras(json.extra);
                }
                if (json.extra?.showSuccessOptInInfo && json?.messages) {
                    amplitude.getInstance().logEvent(OPT_IN_BETA_JOINED_SCREEN_SHOWN);
                    props.modalRef.current?.open(
                        <ModalComponent isVerticalCentered canCloseModal={false} modalRef={props.modalRef}>
                            <InfoPage
                                insideModalComponent
                                animatedIconSuccess
                                iconColor="primary"
                                headerText={json.messages?.successOptInBetaTitle}
                                secondaryText={<DangerouslyHtml sanitizeAllHtmlTags dangerouslyHtml={json.messages?.successOptInBetaMessage} />}
                                primaryButtonCaption={json.messages?.gotIt}
                                primaryButtonType="button"
                                primaryButtonOnClick={() => props.modalRef.current?.close()}
                            />
                        </ModalComponent>,
                    );
                }
                props.toggleSpinner(false);
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    const getSteps = () => {
        let steps = [];
        if (slides) {
            steps = slides.map((slide) => {
                return (
                    <StoryLayout
                        key={slide.order}
                        topButtonCaption={props.hasTopButton ? notNowButton : null}
                        onTopButtonClick={() => {
                            props.popupFullwidthRef.current?.close();
                        }}
                        title={slide.title}
                        subtitle={<DangerouslyHtml dangerouslyHtml={slide.subtitle} />}
                        imgA={slide.web_a_bg_img_url}
                        imgA2x={slide.web_a2x_bg_img_url}
                        contentPosition={slide.position}
                        bottomButtonCaption={optInButton}
                        onBottomButtonClick={doRequest}
                        variant="secondary_base"
                    />
                );
            });
        }
        return steps;
    };

    return <>{imagesLoaded && <Stories steps={getSteps()} isInverted infinityLoop duration={duration} />}</>;
};

BetaPromoStories.propTypes = {
    sliders: PropTypes.object,
    popupFullwidthRef: PropTypes.shape({ current: PropTypes.object }),
    modalRef: PropTypes.shape({ current: PropTypes.object }),
};
export default connect(null, { addExtras, toggleSpinner })(BetaPromoStories);
